import { SequenceLayoutItem } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { IWPGBlockAttributesCompare } from 'app/helpers/IWPGBlockAttributesCompare'

interface IAttributes {
  illustration?: string
  illustrationAlt?: string
  title: string
  isLast?: boolean
}

const SequenceLayoutItemBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <SequenceLayoutItem
      image={<LazyLoadImage src={attributes.illustration} alt={attributes.illustrationAlt} />}
      title={attributes.title}
      isLast={Boolean(attributes.isLast)}
    />
  )
}

export default React.memo(SequenceLayoutItemBlock, IWPGBlockAttributesCompare)
